import React from "react"

const SingleImg = ({
  imgsrc = imgsrc
}) => {
  const imgSrc = "data:image/png;base64," + imgsrc
  return <img src={imgSrc} />
}

export default SingleImg